import { type ProductCardProduct } from '@/features/shop/components/ProductCard/types'
import { ProductCardPrice } from '@/features/shop/components/ProductCard/price/ProductCardPrice'
import { ProductCardPromotion } from '@/features/shop/components/ProductCard/price/ProductCardPromotion'
import { getProductDetails } from '@/features/shared/utils/getProductDetails'
import { SkeletonConsumer } from '@/features/shared/components/SkeletonLoader'
import styled from 'styled-components'

type Props = {
  product: ProductCardProduct
  hideSecondaryDetails?: boolean
}

export const ProductCardPriceAndPromotion = ({ product, hideSecondaryDetails }: Props) => {
  const { oos = false } = product
  const { hasPromotion } = getProductDetails(product)

  return (
    <SkeletonConsumer width={50} height={20}>
      <LineContainer>
        <ProductCardPrice product={product} />
      </LineContainer>
      {!hideSecondaryDetails && !oos && !!hasPromotion && (
        <ProductCardPromotion product={product} />
      )}
    </SkeletonConsumer>
  )
}

const LineContainer = styled.div`
  display: flex;
  align-items: end;
`
